/** Clave sessionStorage al hacer clic en notificación de examen de ubicación */
export const EXAMEN_ABRIR_CHAT_KEY = 'examenAbrirChat'

/**
 * Últimos 10 dígitos (mismo criterio que twiliochat.controllers / twilioTmp).
 */
export function telefonoUltimos10 (valor) {
  if (valor == null || valor === '') return ''
  const digits = String(valor).replace(/\D/g, '')
  return digits.length >= 10 ? digits.slice(-10) : digits
}

/**
 * Normaliza payload del socket (string legacy o objeto).
 */
export function parseExamenCompletadoPayload (body) {
  if (body == null) return null
  if (typeof body === 'string') {
    const folio = body.trim()
    return folio ? { folio, accion: 'examen-ubicacion' } : null
  }
  if (typeof body !== 'object') return null

  const folio = body.folio != null ? String(body.folio).trim() : (body.mss != null ? String(body.mss).trim() : '')
  const telefono = body.telefono != null ? String(body.telefono).trim() : ''
  const twilio = body.twilio != null ? String(body.twilio).trim() : ''
  const idprospectos = body.idprospectos != null ? Number(body.idprospectos) : 0

  if (!folio && !telefono && !twilio && !idprospectos) return null

  return {
    accion: 'examen-ubicacion',
    folio,
    telefono,
    twilio,
    idprospectos: idprospectos || 0,
    nombre_completo: body.nombre_completo || '',
    usuario_asignado: body.usuario_asignado || 0,
    vendedora: body.vendedora || '',
    escuela: body.escuela != null ? Number(body.escuela) : 1,
  }
}

/** escuela 1 = Twilio Unificado (INBI), 2 = Twilio FAST */
export function nombreRutaTwilioExamen (escuela) {
  return Number(escuela) === 2 ? 'TwilioFast' : 'twilioUnificado'
}

export function guardarExamenAbrirPendiente (payload) {
  try {
    sessionStorage.setItem(EXAMEN_ABRIR_CHAT_KEY, JSON.stringify(payload))
  } catch (e) {
    console.warn('[examenUbicacionNotify] sessionStorage', e)
  }
}

export function leerExamenAbrirPendiente () {
  try {
    const raw = sessionStorage.getItem(EXAMEN_ABRIR_CHAT_KEY)
    if (!raw) return null
    return parseExamenCompletadoPayload(JSON.parse(raw))
  } catch (e) {
    return null
  }
}

export function limpiarExamenAbrirPendiente () {
  try {
    sessionStorage.removeItem(EXAMEN_ABRIR_CHAT_KEY)
  } catch (e) { /* ignore */ }
}

/**
 * Query ?tel= & ?folio= & ?idprospectos= al entrar por router.
 */
export function payloadDesdeRouteQuery (query) {
  if (!query || typeof query !== 'object') return null
  const tel = query.tel != null ? String(query.tel).trim() : ''
  const folio = query.folio != null ? String(query.folio).trim() : ''
  const idp = query.idprospectos != null ? Number(query.idprospectos) : 0
  const escuela = query.escuela != null ? Number(query.escuela) : 0
  if (!tel && !folio && !idp) return null
  return {
    accion: 'examen-ubicacion',
    folio,
    telefono: tel,
    twilio: '',
    idprospectos: idp || 0,
    escuela: escuela || 1,
  }
}

/**
 * Solo aplica al entrar por clic en notificación (query con folio/tel/id).
 * Sin query no se reutiliza sessionStorage para no precargar el buscador al abrir Twilio directo.
 */
export function mergeExamenAbrirPayload (query, stored) {
  const fromQuery = payloadDesdeRouteQuery(query)
  if (!fromQuery) return null
  if (!stored) return fromQuery
  return {
    accion: 'examen-ubicacion',
    folio: fromQuery.folio || stored.folio,
    telefono: fromQuery.telefono || stored.telefono,
    twilio: stored.twilio || fromQuery.twilio,
    idprospectos: fromQuery.idprospectos || stored.idprospectos,
    nombre_completo: stored.nombre_completo || '',
    usuario_asignado: stored.usuario_asignado || 0,
    vendedora: stored.vendedora || '',
    escuela: stored.escuela != null ? stored.escuela : (fromQuery.escuela != null ? fromQuery.escuela : 1),
  }
}

function usuarioUltimos10 (usuario) {
  if (!usuario) return ''
  return telefonoUltimos10(usuario)
}

/** Folio usable en UI (el backend a veces manda 0 si no hay prospecto). */
export function folioChatTexto (chat) {
  if (!chat || chat.folio == null || chat.folio === '' || chat.folio === 0 || chat.folio === '0') {
    return ''
  }
  return String(chat.folio).trim()
}

/**
 * Buscador de lista Twilio: folio, nombre, whatsapp (usuario) y teléfono (últimos 10 dígitos).
 */
export function chatCoincideBusquedaTwilio (chat, query) {
  if (!chat || query == null) return false
  const q = String(query).trim()
  if (!q) return false

  const qNorm = q.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const re = new RegExp(escapeRe(qNorm), 'i')

  const folio = folioChatTexto(chat)
  if (folio && re.test(folio.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
    return true
  }

  const nombre = chat.nombre != null ? String(chat.nombre) : ''
  if (nombre && re.test(nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
    return true
  }

  const usuario = chat.usuario != null ? String(chat.usuario) : ''
  if (usuario && re.test(usuario)) {
    return true
  }

  const digitsQ = q.replace(/\D/g, '')
  if (digitsQ.length >= 7) {
    const busca10 = telefonoUltimos10(digitsQ)
    const u10 = usuarioUltimos10(usuario)
    if (busca10 && u10 && (u10 === busca10 || u10.endsWith(busca10) || busca10.endsWith(u10))) {
      return true
    }
    const telChat = chat.telefono != null ? String(chat.telefono) : ''
    if (telChat && telefonoUltimos10(telChat) === busca10) {
      return true
    }
  }

  if (/^\d+$/.test(q) && chat.idprospectos != null && String(chat.idprospectos) === q) {
    return true
  }

  return false
}

/**
 * Busca chat en lista cargada (mismo criterio que enriquecimiento Twilio).
 */
export function findChatPorProspecto (chats, payload) {
  if (!payload || !Array.isArray(chats) || !chats.length) return null

  if (payload.folio) {
    const folio = String(payload.folio).trim().toUpperCase()
    const porFolio = chats.find(c => c.folio && String(c.folio).trim().toUpperCase() === folio)
    if (porFolio) return porFolio
  }

  if (payload.idprospectos) {
    const idp = Number(payload.idprospectos)
    const porId = chats.find(c => Number(c.idprospectos) === idp)
    if (porId) return porId
  }

  const twilio = payload.twilio ? String(payload.twilio).trim() : ''
  if (twilio) {
    const porTwilio = chats.find(c => c.usuario && String(c.usuario) === twilio)
    if (porTwilio) return porTwilio
    const porTwilioParcial = chats.find(c => c.usuario && String(c.usuario).includes(twilio.replace('whatsapp:', '')))
    if (porTwilioParcial) return porTwilioParcial
  }

  const tel10 = telefonoUltimos10(payload.telefono)
  if (tel10) {
    const porTel = chats.find(c => usuarioUltimos10(c.usuario) === tel10)
    if (porTel) return porTel
  }

  return null
}
